<template>
    <div class="applicationing bg-weight">
        <div class="top">
            <img src="../../../images/reginer.png" alt="">
        </div>

        <div class="main">
            <span>
                <img src="../../../images/user/authenticationSuccess.png" alt="">
            </span>
            <!--<i class="iconfont icon-hook"></i>-->
            <p class="successText">申请提交成功！</p>
            <p class="detail">很高兴收到您的认证申请，审核需要1到3个工作日
                <br/>请保持电话畅通，会有工作人员与您联系！</p>
        </div>
    </div>
</template>
<script>
    import store from '../../../store'
    export default {
        data() {
            return {

            }
        },
        
        created() {
            this.$store.dispatch('getUser');
        }
    }
</script>
<style rel="stylesheet/scss" lang="scss">
    .applicationing{
        width: 1200px;
        margin: 50px auto;
        .top{
            width: 100%;
            height: 212px;
            overflow: hidden;
            img{
                width: 100%;
            }
        }
        .main{
            width: 100%;
            height: 680px;
            text-align: center;
            background: #fff;
            >span{
                display: inline-block;
                margin-top: 192px;
            }
            >i{
               display: inline-block;
                font-size:45px;
                color:#93DB45;
                margin-top: 161px;
            }
            .successText{
                font-family: Helvetica-Bold;
                text-align: center;
                font-size: 18px;
                color: #9ADD51;
                margin-top: 24px;
                font-weight: bold;
            }
            .detail{
                display: inline-block;
                width: 100%;
                text-align: center;
                font-size: 14px;
                margin-top: 21px;
                color: #555555;
                width: 376px;
            }
        }
    }
</style>